import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { urls } from "@/constants/_path";
import Key from "@/constants/_query_key";
import { Organization, fetchOrganization } from "@/fetcher/organization";
import { BaseResponse } from "@/utils/request";

function useOrganization(options?: UseQueryOptions<BaseResponse<Organization>>) {
  const query = useQuery<BaseResponse<Organization>>(
    [Key.organization],
    () => fetchOrganization(),
    {
      refetchOnMount: false,
      ...options,
    }
  );

  return useMemo(
    () => ({
      ...query,
      organization: {
        ...query?.data?.data,
        index_path: query?.data?.data?.index_path ?? urls.LANDING_PAGE_PATH,
        career_index_path: query?.data?.data?.career_index_path ?? query?.data?.data?.index_path,
        career_logo: query?.data?.data?.career_logo ?? query?.data?.data?.logo_url,
        career_web_title: query.data?.data?.career_web_title ?? query.data?.data?.web_title,
        career_instagram_url:
          query.data?.data?.career_instagram_url ?? query.data?.data?.instagram_url,
        white_logo_url: query.data?.data?.white_logo_url ?? query.data?.data?.logo_url,
      } as Organization,
    }),
    [query]
  );
}

export { useOrganization };
